<template>
  <div class='set-pwd-block' data-part="newLogin">
    <mt-header title="设置密码">
      <router-link to="" slot="left">
        <mt-button icon="back" @click="goback()"></mt-button>
      </router-link>
      <!-- <mt-button icon="more" slot="right"></mt-button> -->
    </mt-header>
    <div class="content-box">
      <div class="num-line">
        验证码将发送至<span class="area" v-if="tab==1">+{{areaCode}}</span>
        <span v-if='tab==1'>{{userParam.mobileInput}}</span>
        <span v-if='tab==2'>{{userParam.email}}</span>
      </div>
      <!-- <div v-show="tab==1" class="phone-line" :class="{bottomLine:areaCode!=86}">
        <span class="country code-box" @click="pop2=true" :class="{bottomLine:areaCode==86}">
          <em>+{{areaCode}}</em>
          <i class="iconfont icon-xiala-copy"></i>
        </span>
        <div class="phone-in">
          <div class="separate-box" @click="inputClick('phoneDom')" v-show="areaCode==86">
            <i v-for="i in 11" :class="{bottomLine:areaCode==86}">{{pwdArray[i-1]}}</i>
          </div>
          <input
            v-model="userParam.mobileInput"
            :class="{outStyle:phoneInput}"
            @focus="inputFocus('phoneInput')"
            @input="separateNum('mobileInput','phoneDom')"
            ref="phoneDom"
            type="number"
            placeholder="请输入手机号">
        </div>
      </div> -->
      <!-- <div class="email-line bottomLine" v-show="tab==2">
        <input type="text" placeholder="请输入邮箱" >
      </div> -->
      <div class="validate-line">
        <div class="separate-box" @click="inputClick('codeDom')">
          <i v-for="i in codeNum" :class="{little:codeNum==6}" class="bottomLine">{{codeArray[i-1]}}</i>
        </div>
        <input
          type="text"
          v-model="userParam.code"
          :class="{outStyle:codeInput}"
          @focus="inputFocus('codeInput')"
          @input="separateNum('code','codeDom')"
          ref="codeDom"
          placeholder="请输入验证码">
        <div class="right-btn">
          <span class="get-code" v-show="codestate==0" @click="setCode1()">获取验证码</span>
          <span v-show="codestate==1">已发送{{secondNum}}s</span>
        </div>
      </div>
      <!-- <separateBox @phoneOver="showCodeBox" numType="code" :codeType="tab"></separateBox> -->
      <div class="pwd-line">
        <input v-show="!pwdshow" type="password" placeholder="请设置新密码（6-16个字符）" v-model="userParam.pwdNum">
        <input v-show="pwdshow" type="text" placeholder="请设置新密码（6-16个字符）" v-model="userParam.pwdNum">
        <i class='iconfont icon-yanjing' :class="{noSee:!pwdshow,see:pwdshow}" @click="pwdshow=!pwdshow"></i>
      </div>
      <div class="voice-box" v-show="voiceShow&&tab==1">
        <span v-show="voiceState" @click="voiceVerification(this)">收不到短信？试试<em>语音验证</em></span>
        <span v-show="!voiceState">请注意接听语音验证电话（{{secondNum}}s）</span>
      </div>
      <!-- <div class="submit-line" v-show="nextStep" @click="showCodeBox">
        下一步
      </div> -->
      <div class="submit-line" @click="setPwd">
        确定
      </div>
    </div>

    <mt-popup
      v-model="popupVisible2"
      popup-transition="popup-fade"
      :modal="false"
      class="spinner-box">
      <mt-spinner class="pop-spinner" type="fading-circle"></mt-spinner>
    </mt-popup>
    <mt-popup
      v-model="popupVisible3"
      popup-transition="popup-fade"
      :modal="false"
      class="spinner-box">
      <mt-spinner class="pop-spinner" type="fading-circle"></mt-spinner>
      <!-- <div class="spin-word">加载中</div> -->
    </mt-popup>

    <!-- <mt-popup v-model="pop2" position="bottom" class="addresspop pickerPop">
      <div class='button-line'>
        <button @click="pop2=false">取消</button>
        <span>选择所属国家或地区</span>
        <button @click="selectSure">确定</button>
      </div>
      <mt-picker :slots="countryslot" @change="selectCountry" value-key="ch_name"></mt-picker>
    </mt-popup> -->

    <mt-popup
      :closeOnClickModal="false"
      v-model="patternVerification"
      class="tip-pop"
      popup-transition="popup-fade">
      <div id="TCaptcha"></div>
    </mt-popup>
  </div>
</template>

<script>
  import {ajax,setMessage,getMessage} from '../../assets/js/common'
  import { 
    inputFocus,
    separateNum,
    countryCheck,
    quickReg,
    quickLogin,
    setCode,
    setEmail,
    speechVerification
  } from "../../assets/js/login-common"
  import separateBox from "./separate-num.vue"
  export default{
    name:"set-pwd",
    data(){
      return{
        tab:1,
        userParam:{
          "pwdNum":"",
          "mobileInput":"",
          "email":"",
          "code":"",
        },
        userType:"",
        boxShow:"",
        pwdSet:true,//true表示已设置密码，false未设置
        pwdshow:false,
        voiceShow:false,
        voiceState:true,
        secondNum:60,
        codestate:0,
        pop2:false,
        patternVerification:false,
        popupVisible2:false,
        popupVisible3:false,
        areaCode:86,
        phoneInput:false,
        codeInput:false,
        // pwdArray:[],
        // codeArray:[],
        nextStep:true,//控制下一步按钮的显示
        submitShow:false,//控制登录、注册按钮的显示
        loginRegBtn:true,
        countryslot:[
          {
            flex: 1,
            values: [],
            className: 'slot1',
            textAlign: 'center'
          },
        ],
        patternParam:{
          ticket:"",
          businessId:""
        },
      }
    },
    computed:{
      pwdArray(){
        let array=this.userParam['mobileInput'].toString().split('');
        return array;
      },
      codeArray(){
        let array=this.userParam['code'].toString().split('');
        return array;
      },
      codeNum(){
        let val;
        if(this.tab==1){
          val=4;
        }
        else{
          val=4;
          // val=6;
        }
        return val;
      }
    },
    components:{
      separateBox
    },
    watch:{
      areaCode(val){
        this.inputFocus('phoneInput');
      },
      tab(val){
        if(val==2){
          this.boxShow='pwd';
        }
      }
    },
    mounted(){
      this.$nextTick(()=>{
        // this.countryCheck();
        let setParam=sessionStorage.getItem('setParam');
        // sessionStorage.removeItem('setParam');
        // setParam=JSON.parse(setParam);
        // this.tab=setParam.type;
        // if(this.tab==1){
        //   this.areaCode=setParam.areaCode;
        //   this.userParam.mobileInput=setParam.mobile;
        // }
        // else{
        //   this.userParam.email=setParam.email;
        // }
        if(setParam){
          setParam=JSON.parse(setParam);
          this.tab=setParam.type;
          if(this.tab==1){
            this.areaCode=setParam.areaCode;
            this.userParam.mobileInput=setParam.mobile;
          }
          else{
            this.userParam.email=setParam.email;
            // console.log(this.userParam.email);
          }
          // this.showCodeBox();
          // this.inputFocus('phoneInput');
          // this.separateNum("mobileInput","phoneDom");
        }

      })
    },
    methods:{
      // loginSwitch(){
      //   if(this.boxShow=='code'){
      //     this.boxShow='pwd';
      //   }
      //   else if(this.boxShow=='pwd'){
      //     this.boxShow='code';
      //   }
      // },
      /*注册*/
      // register(val){
      //   console.log('register');
      //   return;
      //   if(this.rePwd==""){
      //     this.Toast("请先输入密码");
      //     return false;
      //   }
      //   let param={};
      //   if(this.tab==1){
      //     param={
      //       mobile:this.reUser,
      //       password:this.rePwd,
      //       code:this.reCode,
      //       checkmethod:"data",
      //       type:"sms",
      //       area:this.areaCode,
      //       invite_code:this.invite_code
      //     };
      //   }
      //   else if(this.tab==2){
      //     let name=$("#login-name").val();
      //     param={
      //       email:name,
      //       password:this.rePwd,
      //       code:this.reCode,
      //       checkmethod:"data",
      //       type:"email",
      //       invite_code:this.invite_code
      //     };
      //   }
      //   var that=this;
      //   this.redelay=0;
      //   // this.popupVisible2=true;
      //   ajax(this,this.extendApi.userReg,param,(data)=>{
      //     // this.popupVisible2=false;
      //     this.redelay=1;
      //     if(data.code==200){
      //       this.popupVisible2=false;
      //       if(this.tab==1){
      //         this.login(this.reUser,this.rePwd,this.areaCode);
      //       }
      //       if(this.tab==2){
      //         this.login(name,this.rePwd);
      //       }
      //     }
      //     else{
      //       Toast(data.message);
      //     }
      //   },"post");

      // },
      setPwd(){
        let arr={
          "1":"sms",
          "2":"email"
        };
        let param={
          type:arr[this.tab],
          area:this.areaCode,
          mobile:this.userParam.mobileInput,
          email:this.userParam.email,
          password:this.userParam.pwdNum,
          code:this.userParam.code,
        };
        let paramLogin={};
        for(let x in param){
          paramLogin[x]=param[x];
        }
        paramLogin.redirect_uri="https://zhaobi.com";
        paramLogin.logintype="password";
        paramLogin.broker_code="";
        paramLogin.password=this.userParam.pwdNum;

        ajax(this,this.extendApi.setPassword,param,(data)=>{
          if(data.code==200){
            quickLogin(this,paramLogin);
          }
          else{
            this.Toast(data.message);
            // this.userParam.code="";
            // this.userParam.pwdNum="";
          }
        },'POST');
      },
      //回调函数：验证码页面关闭时回调
      cbfn(retJson) {
        console.log(retJson);
        this.patternVerification=false;
        capDestroy();
        if (retJson.ret == 0) {
        // 用户验证成功
          this.patternParam.ticket=retJson.ticket;
          this.Toast("验证成功");
          this.setCode1();
        }
        else {
            //用户关闭验证码页面，没有验证
        }
      },
      /*发送验证码*/
      setCode1(){
        var codetype="quick";
        var vparam;
        vparam="FzmRandom";
        if(this.tab==1){
          if(!this.voiceState){
            return false;
          }
          if(this.userParam.mobileInput==""){
            this.Toast("请先输入手机号");
            return false;
          }
          this.voiceShow=false;
          this.popupVisible2=true;

          // this.codestate=1;
          // return;

          setCode(this,codetype,vparam,this.userParam.mobileInput,(data)=>{
            this.popupVisible2=false;
          },this.patternParam.ticket,this.patternParam.businessId);
        }
        else if(this.tab==2){
          // let name=$("#login-name").val();
          let name=this.userParam.email;
          if(name==""){
            this.Toast("请先输入邮箱");
            return false;
          }
          this.popupVisible2=true;
          // vparam="FzmDateTime|FzmRandom";
          setEmail(this,codetype,vparam,name,(data)=>{
            this.popupVisible2=false;
          },this.patternParam.ticket,this.patternParam.businessId);
        }
      },
      /*语音验证*/
      voiceVerification(){
        // if(this.reUser==""){
        //   this.Toast("请先输入手机号");
        //   return false;
        // }
        let param={
          area:this.areaCode,
          mobile:this.userParam.mobileInput,
          codetype:'quick'
        };
        speechVerification(this,param);
      },
      inputClick(val){
        this.$refs[val].focus();
      },
      /*拆分input输入值*/
      separateNum(val,ref){
        separateNum(val,ref,this);
        // let array=this.userParam[val].toString().split('');
        // if(val=='mobileInput'){
        //   this.pwdArray=array;
        // }
        // else{
        //   this.codeArray=array;
        // }
        // if(array.length>10){
        //   this.$refs[ref].blur();
        // }
        // if(array.length==11){
        //   this.showCodeBox();
        // }
        // if(array.length==0){
        //   this.showCodeBox();
        // }
      },
      // /*显示验证码输入框*/
      // showCodeBox(){
      //   this.nextStep=false;
      //   this.submitShow=true;
      //   this.userType='login';
      //   if(this.userType=='reg'){
      //     this.boxShow='code';
      //   }
      //   else{
      //     if(this.pwdSet){
      //       this.boxShow='pwd';
      //     }
      //     else{
      //       this.boxShow='code';
      //     }
      //   }
      // },
      /*手机输入框获取焦点*/
      inputFocus(val){
        inputFocus(val,this);
        // if(val=='phoneInput'){
        //   if(this.areaCode==86){
        //     this.phoneInput=true;
        //   }
        //   else{
        //     this.phoneInput=false;
        //   }
        // }
        // else{
        //   this[val]=true;
        //   // if(this.tab==1){
        //   //   this[val]=true;
        //   // }
        //   // else{
        //   //   this[val]=false;
        //   // }
        // }
      },
      /*手机国家获取*/
      // countryCheck(){
      //   let param={
      //     type:"code",
      //   };
      //   this.countryslot[0].values=[];
      //   ajax(this,this.extendApi.countryList,param,(data)=>{
      //     if(data.code==200){
      //       for(let i=0;i<data.data.length;i++){
      //         this.countryslot[0].values.push(data.data[i]);
      //       }
      //     }
      //   },"GET");
      // },
      // selectSure(){
      //   this.pop2=false;
      //   this.areaCode=this.countryVal.code;
      // },
      /*手机国家选择*/
      // selectCountry(picker, values){
      //   this.countryVal=values[0];
      // },
      // tabSwitch(val){
      //   this.tab=val;
      // }
    }
  }
</script>

<style>
  .set-pwd-block{
    .mint-header{
      background-color: transparent;
    }
    .num-line{
      padding-left: .373rem;
      font-size:15px;
    }
    .area{
      margin-right:.107rem;
    }
    .btn-box{
      flex: 1;
      text-align: center;
      font-size: 0;
      button{
        @mixin font-dpr 16;
        width: 2.6rem;
        height: 0.853rem;
        border:1px solid $font-color1;
        background-color: transparent;
        color: $font-color1;
      }
      .active{
        background-color: $font-color1;
        color: $bg-two;
        font-weight: bold;
      }
      button:first-child{
        border-bottom-left-radius:0.133rem;
        border-top-left-radius:0.133rem;
      }
      button:last-child{
        border-bottom-right-radius:0.133rem;
        border-top-right-radius:0.133rem;
      }
    }
  }
</style>




// WEBPACK FOOTER //
// src/views/login/setPwd.vue